<ndt-login-view
   [isRelogin]="true"
   [username]="data.username"
   [appStartCallState]="appStartCallState"
   [loginCallState]="loginCallState"
   (loginClicked)="onLoginClick($event)"
   (cancelClicked)="onCancelClick()"
   (loginWithSSO)="onLoginWithSSO()"
   [loginError]="loginError$ | async"
   [hasSaml2Authentication]="hasSaml2Authentication$ | async"
></ndt-login-view>
